import React from "react";
import { twMerge } from "tailwind-merge";

interface SectionProps {
  children: React.ReactNode;
  className?: string;
}

export default function CredSection({ children, className }: SectionProps) {
  return <div className={twMerge(className, "mx-auto w-full px-2 py-6 md:px-8 md:py-12 lg:max-w-7xl")}>{children}</div>;
}
